import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  refundContainer: {
    height:"100%",
    display:"grid",
    gridTemplateRows: "1fr auto auto"
  },
  innerContainer: {
    width: 400,
    padding:16,
  },
  value: {
    marginBottom: theme.spacing(3)
  },
  submitButton: {
    minWidth: 200
  },
  refundSuccessful: {
    minWidth: 200,
    backgroundColor: "#4caf50",
    color: "#fff !important"
  },
  buttonRight: {
    margin: theme.spacing(2),
    float: "right",
    marginRight: 0,
  },
  warningAlert: {
    width: "100%",
    border: "1px solid",
    alignItems: "center",
    backgroundColor:theme.palette.warning.main,
    color:theme.palette.text.primary,
    "& .MuiAlert-icon": {
      color:theme.palette.text.primary
    }
  },
  buttonRow: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    gap: theme.spacing(2)
  },
  centerAlign: {
    justifyContent: "center",
    display: "flex"
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-start",
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  coloredLineSpacing: {
    marginBottom: theme.spacing(3),
  },
  circularProgress: {
    position: "absolute",
    top: "20%",
    left: "48%",
    marginTop: -5,
    marginLeft: -5,
    },
  closeButton:{
    paddingRight:"8px"
  },
  dividerTop:{
    marginBottom:15,
    marginTop:10
  }
}));